import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class InsightRepositoryService extends BaseRepositoryService<
  ModelRegistry['insight']
> {
  recordName = 'insight';
  implementMethods = ['query'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/insight': InsightRepositoryService;
  }
}
